/* ═══════════════════════════════════════════════════════════════════════════
   Štampa agencijskog naloga — „NALOG ZA PREVOZ".

   Agencijski nalog se NE štampa na obrascu putnog naloga. Putni nalog je
   zvanični obrazac za teretno vozilo (vučno, prikolica, vozači, dozvole) i
   govori o NAŠEM vozilu; kod agencijskog naloga tih podataka nema, pa bi se
   odštampao prazan obrazac. Ovo je drugi dokument — onaj koji se daje
   prevozniku: njegovo vozilo i vozač, relacija, cena i rok plaćanja.

   Dokument se gradi kao HTML string, ne kroz ReactDOM u novom prozoru: nema
   stanja ni interakcije, pa je jedan `document.write` i `print()` dovoljan.
   Zato svaka vrednost ide kroz `esc` — podaci su korisnički unos i u HTML-u
   ne smeju da se tumače kao oznake.

   Natpisi dolaze kroz `t` jer prozor štampe stoji van React stabla, pa u njemu
   nema `useTranslation`.
   ═══════════════════════════════════════════════════════════════════════════ */

const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
));

/* Prazno polje u odštampanom dokumentu ostaje crta, da se vidi da nije
   izostavljeno nego da podatka nema. */
const vred = (v) => {
    const s = String(v ?? '').trim();
    return s === '' ? '&ndash;' : esc(s);
};

const red = (natpis, vrednost, sirina) => `
    <td class="nat"${sirina ? ` style="width:${sirina}"` : ''}>${esc(natpis)}</td>
    <td class="vre">${vred(vrednost)}</td>`;

export default function handlePrintAgencijski(podaci, t) {
    const nalog = podaci?.nalog || {};
    const firma = podaci?.firma || {};
    const prevoznik = podaci?.prevoznik || {};
    const relacija = Array.isArray(podaci?.relacija) ? podaci.relacija : [];

    const strane = `
        <table class="blok">
            <tr><th colspan="2">${esc(t('anStampa.izdavalac'))}</th>
                <th colspan="2">${esc(t('ture.prevoznik'))}</th></tr>
            <tr>
                <td class="nat">${esc(t('admin.nazivFirme'))}</td><td class="vre">${vred(firma.naziv)}</td>
                <td class="nat">${esc(t('admin.nazivFirme'))}</td><td class="vre">${vred(prevoznik.naziv)}</td>
            </tr>
            <tr>
                <td class="nat">${esc(t('admin.adresa'))}</td><td class="vre">${vred(firma.adresa)}</td>
                <td class="nat">${esc(t('admin.adresa'))}</td><td class="vre">${vred(prevoznik.adresa)}</td>
            </tr>
            <tr>
                <td class="nat">${esc(t('admin.mesto'))}</td><td class="vre">${vred(firma.mesto)}</td>
                <td class="nat">${esc(t('admin.mesto'))}</td><td class="vre">${vred(prevoznik.grad)}</td>
            </tr>
            <tr>
                <td class="nat">${esc(t('admin.pib'))}</td><td class="vre">${vred(firma.pib)}</td>
                <td class="nat">${esc(t('admin.pib'))}</td><td class="vre">${vred(prevoznik.pib)}</td>
            </tr>
            <tr>
                <td class="nat">${esc(t('admin.maticniBroj'))}</td><td class="vre">${vred(firma.mb)}</td>
                <td class="nat">${esc(t('admin.maticniBroj'))}</td><td class="vre">${vred(prevoznik.mb)}</td>
            </tr>
            <tr>
                <td class="nat">${esc(t('admin.telefon'))}</td><td class="vre">${vred(firma.telefon)}</td>
                <td class="nat">${esc(t('admin.telefon'))}</td><td class="vre">${vred(prevoznik.telefon)}</td>
            </tr>
        </table>`;

    const prevoz = `
        <table class="blok">
            <tr><th colspan="4">${esc(t('anStampa.podaciPrevoza'))}</th></tr>
            <tr>${red(t('ture.voziloPrevoznika'), nalog.vozilo, '22%')}${red(t('ture.vozacPrevoznika'), nalog.vozac, '22%')}</tr>
            <tr>${red(t('ture.brojPasosa'), nalog.brojPasosa)}${red(t('ture.telefonPrevoznika'), nalog.telefon)}</tr>
            <tr>${red(t('ture.tipKamiona'), nalog.tipKamiona)}${red(t('ture.statusTure'), nalog.statusTure)}</tr>
            <tr>${red(t('ture.datumPolaska'), nalog.datumPolaska)}${red(t('ture.datumDolaska'), nalog.datumDolaska)}</tr>
            <tr>${red(t('ture.cenaPrevozniku'), [nalog.cena, nalog.valuta].filter(Boolean).join(' '))}${red(t('ture.rokPlacanjaPrevozniku'), nalog.rokPlacanja)}</tr>
            <tr>${red(t('ture.odgovornoLice'), nalog.odgovornoLice)}${red(t('ture.kreirao'), nalog.kreiraoNalog)}</tr>
        </table>`;

    const relacijaBlok = `
        <table class="blok">
            <tr><th colspan="4">${esc(t('nova.relacija'))}</th></tr>
            ${relacija.length === 0 ? `
            <tr><td class="prazno" colspan="4">${esc(t('anStampa.nemaRadnih'))}</td></tr>
            <tr><td class="rucno" colspan="4">&nbsp;</td></tr>
            <tr><td class="rucno" colspan="4">&nbsp;</td></tr>
            <tr><td class="rucno" colspan="4">&nbsp;</td></tr>` : `
            <tr class="zag">
                <td style="width:18%">${esc(t('ture.radniNalog'))}</td>
                <td style="width:22%">${esc(t('nova.klijent'))}</td>
                <td style="width:30%">${esc(t('ture.utovari'))}</td>
                <td style="width:30%">${esc(t('ture.istovari'))}</td>
            </tr>
            ${relacija.map(r => `
            <tr>
                <td class="vre">${vred(r.brojRadnog)}</td>
                <td class="vre">${vred(r.klijent)}</td>
                <td class="vre">${vred(r.utovari)}</td>
                <td class="vre">${vred(r.istovari)}</td>
            </tr>${String(r.napomenaZaVozaca ?? '').trim() === '' ? '' : `
            <tr>
                <td class="nat">${esc(t('anStampa.napomenaVozacu'))}</td>
                <td class="vre" colspan="3">${vred(r.napomenaZaVozaca)}</td>
            </tr>`}`).join('')}`}
        </table>`;

    const napomena = `
        <table class="blok">
            <tr><th>${esc(t('nova.napomena'))}</th></tr>
            <tr><td class="vre napomena">${vred(nalog.napomena)}</td></tr>
        </table>`;

    const potpisi = `
        <table class="potpisi">
            <tr>
                <td>${esc(t('anStampa.zaIzdavaoca'))}</td>
                <td class="mp">M.P.</td>
                <td>${esc(t('anStampa.zaPrevoznika'))}</td>
            </tr>
            <tr class="linije">
                <td><span></span></td><td></td><td><span></span></td>
            </tr>
        </table>`;

    const dokument = `<!DOCTYPE html>
<html lang="sr">
<head>
<meta charset="utf-8" />
<title>${esc(t('anStampa.naslov'))} ${esc(nalog.brojNaloga || '')}</title>
<style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, Helvetica, sans-serif; font-size: 9pt; color: #000; padding: 12mm 10mm; }
    @page { size: A4 portrait; margin: 0; }

    .zaglavlje { display: flex; justify-content: space-between; align-items: flex-end;
                 border-bottom: 0.6mm solid #000; padding-bottom: 2mm; margin-bottom: 4mm; }
    .naslov { font-size: 15pt; font-weight: bold; letter-spacing: 0.4mm; }
    .zaglavlje .desno { text-align: right; font-size: 9pt; line-height: 1.5; }
    .zaglavlje .broj { font-size: 11pt; font-weight: bold; }

    table.blok { width: 100%; border-collapse: collapse; margin-bottom: 3mm; table-layout: fixed; }
    table.blok th { background: #ececec; border: 0.25mm solid #000; padding: 1.4mm 2mm;
                    text-align: left; font-size: 9pt; text-transform: uppercase; letter-spacing: 0.15mm; }
    table.blok td { border: 0.25mm solid #000; padding: 1.4mm 2mm; vertical-align: top;
                    word-wrap: break-word; }
    td.nat { background: #f7f7f7; font-size: 8pt; color: #333; width: 22%; }
    td.vre { font-weight: bold; }
    td.vre.napomena { font-weight: normal; min-height: 14mm; height: 14mm; }
    tr.zag td { background: #f7f7f7; font-size: 8pt; color: #333; font-weight: bold; }
    td.prazno { font-style: italic; color: #333; }
    td.rucno { height: 7mm; }

    table.potpisi { width: 100%; margin-top: 10mm; border-collapse: collapse; }
    table.potpisi td { width: 40%; font-size: 8pt; padding-bottom: 1mm; vertical-align: bottom; }
    table.potpisi td.mp { width: 20%; text-align: center; }
    table.potpisi tr.linije td span { display: block; border-top: 0.25mm solid #000; padding-top: 1mm; }

    @media print { body { padding: 10mm 8mm; } table.blok { page-break-inside: auto; } tr { page-break-inside: avoid; } }
</style>
</head>
<body>
    <div class="zaglavlje">
        <div class="naslov">${esc(t('anStampa.naslov'))}</div>
        <div class="desno">
            <div class="broj">${vred(nalog.brojNaloga)}</div>
            <div>${esc(t('anStampa.datumIzdavanja'))}: ${vred(nalog.datumIzdavanja)}</div>
        </div>
    </div>
    ${strane}
    ${prevoz}
    ${relacijaBlok}
    ${napomena}
    ${potpisi}
</body>
</html>`;

    const prozor = window.open('', '_blank', 'width=1000,height=700');
    if (!prozor) return;   /* blokiran popup — bez ovoga bi puklo na null */

    prozor.document.open();
    prozor.document.write(dokument);
    prozor.document.close();

    /* Isti obrazac kao kod ostalih štampa: kratko odlaganje da prozor stigne da
       iscrta sadržaj pre `print()`, inače se otvori prazan dijalog. */
    setTimeout(() => {
        prozor.focus();
        prozor.print();
    }, 400);
}
